import {
  DWELLER_USER_ROLE,
  LANDLORD_USER_ROLE,
} from '../../../../constants/user'

export const EMAIL_RECIPIENTS_GROUP_FIELD_NAME = 'group'

export const EMAIL_RECIPIENTS_ROLE_FIELD_NAME = 'role'

export const EMAIL_RECIPIENTS_BUILDING_FIELD_NAME = 'building'

export const EMAIL_RECIPIENTS_FLAT_FIELD_NAME = 'flat'

export const EMAIL_RECIPIENTS_USER_INFO_STATUS_FIELD_NAME = 'userInfoStatus'

export const EMAIL_RECIPIENTS_WITH_PROPERTY_OWNERS_FIELD_NAME =
  'withPropertyOwners'

export const STAFF_VALUE = 'staff'

export const TENANT_VALUE = 'tenant'

export const GROUP_OPTIONS = [
  { label: 'Email.TenantFilterOptionKey', value: TENANT_VALUE },
  { label: 'Email.StaffFilterOptionKey', value: STAFF_VALUE },
]

export const ROLE_OPTIONS = [
  { label: 'Email.DwellersOnlyFilterOptionKey', value: DWELLER_USER_ROLE },
  { label: 'Email.LandlordsOnlyFilterOptionKey', value: LANDLORD_USER_ROLE },
]
